export default __webpack_public_path__ + "static/media/home-bg-old.8331fcb7.png";